<div *ngIf="hasError()" class="error">
  <span>{{ mapToErrorMessage() }}</span>
</div>
